import { render, staticRenderFns } from "./FileTypeUnsupported.vue?vue&type=template&id=786c5fb8&scoped=true&"
import script from "./FileTypeUnsupported.vue?vue&type=script&lang=js&"
export * from "./FileTypeUnsupported.vue?vue&type=script&lang=js&"
import style0 from "./FileTypeUnsupported.vue?vue&type=style&index=0&id=786c5fb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786c5fb8",
  null
  
)

export default component.exports